import Vue from 'vue'
import Vuex from 'vuex'
import manager from './modules/manager'
import user from './modules/user'
import report from './modules/report'
import createPersistedState from 'vuex-persistedstate'
import storage from 'good-storage'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    manager,
    user,
    report
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => storage.session.get(key),
        setItem: (key, value) => storage.session.set(key, value),
        removeItem: key => storage.session.remove(key)
      }
    })
  ]
})

if (module.hot) {
  // 使 action 和 mutation 成为可热重载模块
  module.hot.accept(['./modules/manager', './modules/user', './modules/report'], () => {
    // 获取更新后的模块
    // 因为 babel 6 的模块编译格式问题，这里需要加上 `.default`
    const manager = require('./modules/manager').default
    const user = require('./modules/user').default
    const report = require('./modules/report').default
    // 加载新模块
    store.hotUpdate({
      modules: {
        manager,
        user,
        report
      }
    })
  })
}

export default store


// WEBPACK FOOTER //
// ./src/store/index.js